<button adEl="menuTrigger" mat-icon-button [matMenuTriggerFor]="userMenu">
  <mat-icon adEl>person</mat-icon>
</button>
<mat-menu adEl="userMenu" #userMenu>
  <div adEl="userEmail" mat-menu-item [disabled]="true">
    {{(authService.currentUser | async)?.email}}
  </div>
  @for (item of menuItems; track $index) {
  <button adEl mat-menu-item (click)="handleMenuItemClick(item)">
    @if (item.icon) {
    <mat-icon adEl class="material-icons-outlined">{{item.icon}}</mat-icon>
    }
    <span adEl>{{item.label}}</span>
  </button>
  } @if (allowImpersonation) {
  <button adEl="switchUserButton" mat-menu-item (click)="switchUser()">
    <mat-icon adEl class="material-icons-outlined">swap_horiz</mat-icon>
    <span adEl>Switch User</span>
  </button>
  }
  <button adEl="logoutButton" mat-menu-item (click)="logout()">
    <mat-icon adEl class="material-icons-outlined">logout</mat-icon>
    <span adEl>Logout</span>
  </button>
</mat-menu>
